import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    Button,
    notification,
    Form,
    Select,
    Input,
} from "antd";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../config";
import Loader from "../../components/Loader";

const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;

function ReviewForm() {
    const { blogId } = useParams(); // Extract reportElementId from URL
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [bannerImage, setBannerImage] = useState('');
    const [selectedPage, setSelectedPage] = useState('');
    const [selectedBannerImage, setSelectedBannerImage] = useState(null)
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Check if reportElementId exists to determine if it's an update mode
        if (blogId) {
            setIsUpdateMode(true);
            fetchDetails();
        }
    }, [blogId]);

    const fetchDetails = async () => {
        try {
            const response = await axios.get(`${baseUrl}/api/review/${blogId}`);
            if (response.status === 200) {
                setSelectedPage(response.data.result.page);
                setSelectedBannerImage(response?.data?.result?.image || null);
                form.setFieldsValue(response.data.result); // Populate form fields with fetched data
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

    const onFinish = async (values) => {
        try {
            let formData = new FormData();
            for (let key in values) {

                formData.append(key, values[key]);
            }
            if (bannerImage) {
                formData.append('file', bannerImage);
            }
            setLoading(true);
            if (isUpdateMode) {
                formData.append('id', blogId)
                const response = await axios.patch(`${baseUrl}/api/review`, formData, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                    },
                });
                if (response.status === 200) {
                    notification.success({
                        message: 'Success',
                        description: 'Review updated successfully!',
                        placement: 'topRight'
                    });
                    navigate('/review');
                } else {
                    notification.info({
                        message: 'Info',
                        description: response.data.message,
                        placement: 'topRight'
                    });
                }
            } else {
                const response = await axios.post(`${baseUrl}/api/review`, formData, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                    },
                });
                if (response.status === 200) {
                    notification.success({
                        message: 'Success',
                        description: 'Review added successfully!',
                        placement: 'topRight'
                    });
                    form.resetFields();
                    navigate('/review');
                } else {
                    notification.info({
                        message: 'Info',
                        description: response.data.message,
                        placement: 'topRight'
                    });
                }
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        } finally {
            setLoading(false);
        }
    };

    function bannerImageSelect(brandLogo) {
        setBannerImage(brandLogo);
    }

    return (
        <>
            <Loader visible={loading} />
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title={isUpdateMode ? "Update Review" : "Add Review"}
                        >
                            <Form style={{ "padding": "20px" }} form={form} onFinish={onFinish} layout="vertical">
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12} lg={12}>
                                        <Item
                                            label="User Name"
                                            name="userName"
                                            rules={[{ required: true, message: 'Please enter user name.' }]}
                                        >
                                            <Input placeholder="Please enter user name" />
                                        </Item>
                                    </Col>
                                    <Col xs={24} sm={12} lg={12}>
                                        {isUpdateMode ?
                                            <Item
                                                label="User Image"
                                            >
                                                <Input type="file" accept="image/*" onChange={(e) => bannerImageSelect(e.target.files[0])} />
                                            </Item>
                                            :
                                            <Item
                                                label="User Image"
                                                name="image"
                                                rules={[{ required: isUpdateMode ? false : true, message: 'Please select image.' }]}
                                            >
                                                <Input type="file" accept="image/*" onChange={(e) => bannerImageSelect(e.target.files[0])} />
                                            </Item>
                                        }
                                        {selectedBannerImage &&
                                            <img width={100} height={100} src={baseUrl+'/'+selectedBannerImage} />
                                        }
                                    </Col>
                                    <Col xs={24} sm={12} lg={12}>
                                        <Item
                                            label="Message"
                                            name="message"
                                            rules={[{ required: true, message: 'Please enter message.' }]}
                                        >
                                            <TextArea placeholder="Please enter message" />
                                        </Item>
                                    </Col>
                                    <Col xs={24} sm={12} lg={12}>
                                        <Item
                                            label="Status"
                                            name="enabled"
                                            rules={[{ required: true, message: 'Please select status.' }]}
                                        >
                                            <Select placeholder="Please select status">
                                                <Option value={true}>Active</Option>
                                                <Option value={false}>Inactive</Option>
                                            </Select>
                                        </Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={12} lg={8}>
                                        <Item>
                                            <Button type="primary" htmlType="submit">
                                                {isUpdateMode ? "Update" : "Add"}
                                            </Button>
                                        </Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default ReviewForm;
